import PropTypes from "prop-types";
// @mui
import Box from "@mui/material/Box";
// routes
import { usePathname } from "src/routes/hooks";
//
import Footer from "./footer";
import Header from "./header";

// ----------------------------------------------------------------------

export default function MainLayout({ children, addHeaderAndFooter = true }) {
    const pathname = usePathname();

    const isHome = pathname === "/";
    const isAgentView = pathname === "/agent-view";
    const isCustomerView = pathname === "/ai-travel-planner";

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: 1,
            }}
        >
            {isCustomerView || !addHeaderAndFooter ? "" : <Header />}

            {isAgentView ? (
                <div>{children}</div>
            ) : (
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        ...(!isHome && {
                            pt: { xs: 8, md: 10 },
                        }),
                    }}
                >
                    {children}
                </Box>
            )}

            {isAgentView || !addHeaderAndFooter ? "" : <Footer />}
        </Box>
    );
}

MainLayout.propTypes = {
    children: PropTypes.node,
};
